export default __webpack_public_path__ + "static/iwm-north-50acd85ff3884b3dfe229bd267f0cc1f.png";